export const NAVIGATION_REQUEST_EVENT = "pharmhub:navigation-request";
export const HASH_NAVIGATION_REQUEST_EVENT = "pharmhub:hash-navigation-request";

export type NavigationRequestDetail = { proceed: () => void };

export type NavigationGuardOptions = {
  isDirty: () => boolean;
  onClose: () => void;
  onDirty: (proceed: () => void) => void;
  schedule?: (proceed: () => void) => void;
};

export function mountNavigationTransitionGuard(target: EventTarget, options: NavigationGuardOptions): () => void {
  const schedule = options.schedule ?? ((proceed) => window.setTimeout(proceed, 0));
  const handleNavigationRequest = ((event: Event) => {
    const request = event as CustomEvent<Partial<NavigationRequestDetail>>;
    if (typeof request.detail?.proceed !== "function") return;
    event.preventDefault();
    if (options.isDirty()) {
      options.onDirty(request.detail.proceed);
      return;
    }
    options.onClose();
    schedule(request.detail.proceed);
  }) as EventListener;

  target.addEventListener(NAVIGATION_REQUEST_EVENT, handleNavigationRequest);
  target.addEventListener(HASH_NAVIGATION_REQUEST_EVENT, handleNavigationRequest);
  return () => {
    target.removeEventListener(NAVIGATION_REQUEST_EVENT, handleNavigationRequest);
    target.removeEventListener(HASH_NAVIGATION_REQUEST_EVENT, handleNavigationRequest);
  };
}

export function requestNavigationTransition(
  proceed: () => void,
  eventName: typeof NAVIGATION_REQUEST_EVENT | typeof HASH_NAVIGATION_REQUEST_EVENT = NAVIGATION_REQUEST_EVENT,
  target: EventTarget = window,
): boolean {
  const request = new CustomEvent<NavigationRequestDetail>(eventName, {
    cancelable: true,
    detail: { proceed },
  });
  if (!target.dispatchEvent(request)) return false;
  proceed();
  return true;
}
